module.exports = __webpack_public_path__ + "static/5-fb9d4e69f4e8af8a7786a9ed913380ae.jpg";